export default {
  PreChecker: 'Υπάλληλος Προελέγχου',
  SpecialProponent: 'Χειριστής',
  ExecutiveBoardMember: 'Μέλος Επιτροπής',
  President: 'Πρόεδρος',
  VicePresidentA: 'Αντιπρόεδρος Α',
  VicePresidentB: 'Αντιπρόεδρος Β',
  ProcessViewer: 'Διοικητικός Έλεγχος',
  SpecialReappraisalBoardMember: 'Μέλος Ειδ. Επιτρ. Επανεξέτασης',
  Admin: 'Διαχειριστής',
  RegistryAdmin: 'Διαχειριστής Μητρώων',
  PhdRegistry: 'Σύνδεσμος ΕΑΔΔ',
  CouncilMember: 'Μέλος ΔΣ',
  DocutracksUser: 'Χρήστης ΣΗΔΕ (Docutracks)',
  TemporaryUser: 'Προσωρινός χρήστης',
  PrintDecision: 'Καταχωρητής Απόφασης',
  AcademicConsultant: 'Αξιολογητής',
  AcademicDirector: 'Δ/ντής Ακαδ. Αναγνώρισης',
  Auditor: 'Υπάλληλος Αρχής Διαφάνειας',
  bachelor: 'Τίτλος 1ου κύκλου σπουδών',
  master: 'Τίτλος 2ου κύκλου σπουδών',
  phd: 'Τίτλος 3ου κύκλου σπουδών',
  userW_: 'Εξωτερικός Χρήστης',
  precheckerW_: 'Προέλεγχος',
  proponentW_Prechecker: 'Χειριστής από Προέλεγχο',
  proponentW_President: 'Χειριστής από Πρόεδρο',
  proponentW_Board: 'Χειριστής από Εκτελεστική επιτροπή',
  proponentW_Admin: 'Χειριστής από Αναδρομολόγηση',
  viewerW_Proponent: 'Έλεγχος από Χειριστή',
  viewerW_Vice: 'Έλεγχος από Αντιπρόεδρο',
  viewerW_Board: 'Έλεγχος από Εκτελεστική επιτροπή',
  viceW_President: 'Αντιπρόεδρος από Πρόεδρο',
  boardW_President: 'Εκτελεστική επιτροπή από Πρόεδρο',
  boardW_Proponent: 'Εκτελεστική επιτροπή από Εισηγητή',
  boardW_Consultant: 'Εκτελεστική επιτροπή από Ακαδημαϊκό',
  presidentW_Prechecker: 'Πρόεδρος από Προέλεγχο',
  printDecisionW_: 'Καταχωρητής Απόφασης',
  precheckersQueue: 'Ουρά προελέγχου',
  presidentW_PrintDecision: 'Πρόεδρος από Καταχωρητή',
  president_finalized: 'Ολοκληρωμένη-Παραλαβή',
  consultantW_Proponent: 'Αξιολογητής από Χειριστή',
  presidentW_Viewer: 'Πρόεδρος',
  presidentW_AcademicDirector: 'Πρόεδρος',
  boardW_: 'Εκτελεστική επιτροπή',
  REDIRECTION_NEEDED: 'Επαναδρομολόγηση',
  printDecisionW_President: 'Ουρά καταχωρητών',
  deactivated: 'Απενεργοποιημένη',
  reappraisalBoardW_President: 'Ειδ. Επιτρ. Επανεξέτασης',
  proponentW_ReappraisalBoard: 'Χειριστής από Ειδ. Επιτρ. Επανεξέτασης',
  academicDirectorW_Proponent: 'Δ/ντής Ακαδ. Αναγνώρισης από Χειριστή (Επανεξ.)',
  academicDirectorW_ReappraisalBoard: 'Δ/ντής Ακαδ. Αναγνώρισης από Ειδ. Επιτρ. Επανεξ.',
  presidentW_AcademicDirector_Reappraisal: 'Πρόεδρος από Δ/ντή Ακαδ. Αναγνώρισης (Επανεξ.)',
  presidentW_ReappraisalBoard: 'Πρόεδρος από Ειδ. Επιτρ. Επανεξέτασης (επιστροφή)',
  precheckerCompensatoryW_: 'Προέλεγος μετά από Εξετάσεις σε Πανεπιστημιακό Ίδρυμα',
  'ΑΝΑΓΝΩΡΙΣΗΣ ΠΤΥΧΙΟΥ ΜΕ ΣΥΝΕΚΤΙΜΗΣΗ ΜΕΤΑΠΤΥΧΙΑΚΟΥ ΤΙΤΛΟΥ': 'ΒΑΣΙΚΟ ΜΕ ΣΥΝΕΚΤΙΜΗΣΗ',
  'ΑΝΑΓΝΩΡΙΣΗΣ ΒΑΣΙΚΟΥ ΤΙΤΛΟΥ': 'ΒΑΣΙΚΟ',
  'ΑΝΑΓΝΩΡΙΣΗΣ ΔΙΔΑΚΤΟΡΙΚΟΥ ΤΙΤΛΟΥ': 'ΔΙΔΑΚΤΟΡΙΚΟ',
  'ΑΝΑΓΝΩΡΙΣΗΣ ΜΕΤΑΠΤΥΧΙΑΚΟΥ ΤΙΤΛΟΥ': 'ΜΕΤΑΠΤΥΧΙΑΚΟ',
  'ΕΠΑΝΕΞΕΤΑΣΗΣ ΑΙΤΗΜΑΤΟΣ ΑΝΑΓΝΩΡΙΣΗΣ ΤΙΤΛΟΥ ΣΠΟΥΔΩΝ': 'ΕΠΑΝΕΞΕΤΑΣΗΣ ΑΙΤΗΜΑΤΟΣ ΑΝΑΓΝΩΡΙΣΗΣ ΤΙΤΛΟΥ ΣΠΟΥΔΩΝ'
}



// WEBPACK FOOTER //
// ./src/store/dictionary.js